import { Modal, Button, Skeleton } from "@thetreep/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { routes } from "@routes";
import { AgencyInfo } from "@gen/agency/v1/agency_pb";
interface OfflineModalProps {
  isOpen: boolean;
  onClose: () => void;
  agencyInfo?: AgencyInfo;
  messageLabel: string;
}

export function OfflineModal({
  messageLabel,
  agencyInfo,
  isOpen,
  onClose,
}: OfflineModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate(routes.HOME);
  };

  return (
    <Modal size="default" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <span className="font-jakarta font-bold text-text-strong text-md">
          {t("userBookings.offlineTitle")}
        </span>
        <div className="text-neutral-900 whitespace-pre-line max-w-[600px]">
          <p className="font-roboto text-sm text-text-strong">
            {t(messageLabel)}
          </p>
          {agencyInfo ? (
            <>
              <p className="font-roboto text-sm text-text-strong">
                <Trans
                  t={t}
                  values={{
                    agencyName: agencyInfo.alias,
                  }}
                >
                  userBookings.offlineText1
                </Trans>
              </p>
              <p className="font-roboto text-sm text-text-strong mt-4">
                {" "}
                {t("userBookings.offlinePhoneNumber")}:{" "}
                <strong> {agencyInfo.contactPhone} </strong>{" "}
              </p>
              <p className="font-roboto text-sm text-text-strong mb-4">
                {" "}
                {t("userBookings.openHour")}:{" "}
                <strong> {agencyInfo.openingHours} </strong>{" "}
              </p>
            </>
          ) : (
            <Skeleton animation width="100%" height="180px" />
          )}
        </div>
        <div className="flex flex-col gap-2 lg:flex-row lg:justify-between"></div>
        <div className="flex gap-2 justify-end">
          <Button onClick={onClose} kind="outline" size="compact">
            {t("userBookings.offlineClose")}
          </Button>
          <Button onClick={handleConfirm} size="compact">
            {t("userBookings.offlineBackToHome")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
